module.exports = __webpack_public_path__ + "static/OP13-90da2296137d69d9fc4e7b5572cdeb1a.jpg";